/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { NotificationBaseService } from '../notification-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NotificationCount } from '../models/notification-count';
import { NotificationDataEntry } from '../models/notification-data-entry';

@Injectable({ providedIn: 'root' })
export class NotificationControllerService extends NotificationBaseService {

  /**
   * Path part for operation notificationControllerGetMyNotificationCount
   */
  static readonly NotificationControllerGetMyNotificationCountPath = '/v1/my/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyNotificationCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyNotificationCount$Response(params?: {
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<NotificationCount>> {

    const rb = new RequestBuilder(this.rootUrl, NotificationControllerService.NotificationControllerGetMyNotificationCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NotificationCount>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getMyNotificationCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyNotificationCount(params?: {
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<NotificationCount> {

    return this.getMyNotificationCount$Response(params).pipe(
      map((r: StrictHttpResponse<NotificationCount>) => r.body as NotificationCount)
    );
  }

  /**
   * Path part for operation notificationControllerMarkAsRead
   */
  static readonly NotificationControllerMarkAsReadPath = '/v1/my/{id}/mark-as-read';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAsRead$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, NotificationControllerService.NotificationControllerMarkAsReadPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `markAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAsRead(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.markAsRead$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation notificationControllerGetMyNotifications
   */
  static readonly NotificationControllerGetMyNotificationsPath = '/v1/my';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyNotifications$Response(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<NotificationDataEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, NotificationControllerService.NotificationControllerGetMyNotificationsPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<NotificationDataEntry>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getMyNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyNotifications(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<NotificationDataEntry>> {

    return this.getMyNotifications$Response(params).pipe(
      map((r: StrictHttpResponse<Array<NotificationDataEntry>>) => r.body as Array<NotificationDataEntry>)
    );
  }

}
